const httpClientFactory = (config) => {
    // Optional getToken callback: lets the caller keep this client (and anything built on
    // it) identity-stable across token rotations by resolving the token per request.
    const getToken = config.getToken || (() => config.token);
    if (!getToken()) {
        throw new Error('httpClient: no token provided');
    }
    return (url, options = {}) => {
        const token = getToken();
        if (!options.headers) {
            if (options.upload) {
                options.headers = new Headers({
                    Accept: 'application/json',
                    Authorization: `Token ${token}`,
                });
            } else {
                options.headers = new Headers({
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    Authorization: `Token ${token}`,
                });
            }
        }
        if (!options.method) {
            options.method = 'GET';
        }
        return fetch(url, options).then((res) => {
            const status = +res.status;
            const ctype = res.headers.get('Content-Type');

            // console.log('fetch res', res, status, ctype);

            let shouldDecodeJson = false;
            if (ctype === 'application/json' && status !== /* no content */ 204) {
                shouldDecodeJson = true;
            }

            return shouldDecodeJson
                ? res.json().then((data) => ({
                      status: res.status,
                      headers: res.headers,
                      json: data,
                      res: res,
                  }))
                : {
                      status: status,
                      headers: res.headers,
                      json: null,
                      res: res,
                  };
        });
    };
};

export default httpClientFactory;
